import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { User } from '../../store/models/User';
import { Page, TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import { toJS } from 'mobx';
import VerticalForm from '../common/form/VerticalForm';
import { CheckboxInputFormField, TextInputFormField } from '../common/form';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Form } from 'react-final-form';
import LanguageFormField from '../common/form/LanguageFormField';
import { Button, Intent } from '@blueprintjs/core';
import { Link } from 'react-router-dom';
import { TranslatedMessage } from '../common/translation';
import { IconNames } from '@blueprintjs/icons';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import styled from '@emotion/styled';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import { AuthenticationStore, ApplicationStore } from '../../store';

const Container = styled.div`
  display: flex;
  width: 70%;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  & button {
    margin-left: 5px;
  }
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

interface UserFormProps extends WithTranslateProps {
  user?: Instance<typeof User>;
  save: (data: any) => void;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
}

interface UserFormState {
  loading: boolean;
}

@inject('AuthenticationStore', 'ApplicationStore')
@observer
class UserForm extends React.Component<UserFormProps, UserFormState> {
  constructor(props: UserFormProps) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  private impersonate = (ev) => {
    const { AuthenticationStore, user } = this.props;
    AuthenticationStore!.impersonate(user!.userName);
  };

  canEditUser = () => {
    return (
      this.props.AuthenticationStore!.isSuperAdmin ||
      (this.props.user !== undefined &&
        this.props.AuthenticationStore!.isSecretariat &&
        this.props.AuthenticationStore!.secretariatId === this.props.user!.secretaryId)
    );
  };

  public render() {
    const { user, translate, save } = this.props;
    return (
      <Form
        initialValues={toJS(user) || {}}
        onSubmit={save}
        render={({ handleSubmit, form, hasValidationErrors, dirty }) => (
          <form onSubmit={handleSubmit}>
            <LeaveRouteDirtyWrapper blockChange={dirty} />
            <Container>
              <VerticalForm labelWidth={175}>
                <TextInputFormField
                  name="firstName"
                  label={TLCode.Firstname}
                  inline={true}
                  fill={true}
                  required={true}
                />
                <TextInputFormField name="lastName" label={TLCode.Lastname} inline={true} fill={true} required={true} />
                <DivLine>
                  <DivColumn style={{ width: '500px' }}>
                    <TextInputFormField
                      name="userName"
                      label={TLCode.Username}
                      inline={true}
                      fill={true}
                      required={true}
                    />
                  </DivColumn>
                  <DivColumn style={{ width: '200px' }}>
                    {/* <Button
                        text={translate(TLCode.USER_Impersonate)}
                        icon={IconNames.PEOPLE}
                        intent={Intent.DANGER}
                        onClick={() => this.props.ApplicationStore!.navigate(
                          `${Page.PharmacyPage}/${user!.userName}`)}  utilsier le pharmacyId à la place...
                      /> */}
                  </DivColumn>
                </DivLine>
                <DivLine>
                  <DivColumn style={{ width: '500px' }}>
                    <TextInputFormField name="email" label={TLCode.Email} inline={true} fill={true} required={true} />
                  </DivColumn>
                  {user != null && (
                    <DivColumn style={{ width: '300px' }}>
                      <a href={'mailto:' + user!.email + '?subject=Pharmagarde&from=garde@uphoc.be'}>{user!.email}</a>
                    </DivColumn>
                  )}
                </DivLine>
                <TextInputFormField
                  name="password"
                  label={TLCode.Password}
                  inline={true}
                  fill={true}
                  required={user == null}
                />
                <TextInputFormField name="pharmacy" label={TLCode.PHARMACY_Title} inline={true} fill={true} />
                <TextInputFormField name="secretariat" label={TLCode.SECRETARIAT_Title} inline={true} fill={true} />
                <LanguageFormField name="languageCode" required={true} />
                <SimpleTextFormContent label={TLCode.IS_ACTIVE} small={false}>
                  <CheckboxInputFormField name="isActive" inline={true} />
                </SimpleTextFormContent>
              </VerticalForm>
              <ButtonsContainer>
                <Button>
                  <Link to={`${Page.Users}`}>
                    <TranslatedMessage id={TLCode.BackToList} />
                  </Link>
                </Button>
                <Button
                  text={translate(TLCode.GENERAL_Cancel)}
                  icon={IconNames.ERASER}
                  intent={Intent.PRIMARY}
                  onClick={() => form.reset()}
                  disabled={!dirty}
                />
                <Button
                  type={'submit'}
                  text={translate(TLCode.GENERAL_Save)}
                  icon={IconNames.FLOPPY_DISK}
                  intent={Intent.PRIMARY}
                  disabled={hasValidationErrors || !dirty || !this.canEditUser()}
                />
                {/* {this.props.AuthenticationStore!.isSuperAdmin && ( */}
                {this.props.AuthenticationStore!.isSuperAdmin && (
                  <Button
                    text={translate(TLCode.USER_Impersonate)}
                    icon={IconNames.PEOPLE}
                    intent={Intent.DANGER}
                    onClick={this.impersonate}
                  />
                )}
              </ButtonsContainer>
            </Container>
          </form>
        )}
      />
    );
  }
}

export default withTranslate(UserForm);
